import React, { Component } from 'react';
import './App.css';
import Header from './components/header/header';
import Sections from './components/sections/sections';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        {/* <Sections /> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js